<template>
    <v-menu ref="menu" v-model="menu" :close-on-content-click="false"  transition="scale-transition" offset-y min-width="290px">
        <template v-slot:activator="{ on }">
            <v-text-field v-model="computedDateFormatted" :label="label" :prepend-inner-icon="mdiCalendarRange" outlined hide-details v-on="on" readonly placeholder="Tarih"></v-text-field>
        </template>
        <v-date-picker v-model="date" no-title scrollable @input="menu = false"></v-date-picker>
    </v-menu>
</template>


<script>
    import {
        mdiCalendarRange,
    } from '@mdi/js';
    export default {
        name: "inputsdatepicker",
        props: {
            dateModel: {
                default: ""
            },
            label: {
                default: ""
            },
        },
        model: {
            prop: 'dateModel',
            event: 'input'
		},
		data: vm => ({
			date: new Date().toISOString().substr(0, 10),
			dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
			menu: false, 
            mdiCalendarRange: mdiCalendarRange,
		}),
        watch: { 
            date : function(val) {
				this.dateFormatted = this.formatDate(this.date)
				this.$emit("input",this.dateFormatted)
            },
        },
        mounted() {
			if(this.dateModel == "" || this.dateModel.length != 10){
				this.date = this.$moment(new Date()).format("YYYY-MM-DD")
			}else{
				this.date = this.$moment(this.dateModel,"DD.MM.YYYY").format("YYYY-MM-DD")
			}  
        },
        methods: {
            formatDate(date) {
                if (!date) return null 
                const [year, month, day] = date.split('-')
                return `${day}.${month}.${year}`
            },
            parseDate(date) {
                if (!date) return null 
                const [day, month, year] = date.split('/')
                return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
            },
        },
        computed: {
            computedDateFormatted() {
                return this.formatDate(this.date)
            },
        },
    }
</script>